<template>
  <div :class="$style.result">
    <div :class="$style.content" v-if="resultShow">
      <img
        :src="result ? `${$cdnUrl}/success.png` : `${$cdnUrl}/error.png`"
        alt
        :class="$style.state"
      />
      <p :class="result && $style.success">{{result ? "— 支付成功 —" : "— 支付失败 —"}}</p>
      <p :class="$style.desc">请到游戏内查询具体结果</p>
    </div>
    <img v-if="authVisible" :src="`${$cdnUrl}/auth.jpg`" alt="" :class="$style.auth" @click="authVisible = false">
  </div>
</template>

<script>
import { officialAccountsPay, checkOrder as checkOrderApi, getOrderSn, checkOs } from "@/api/pay";
import wxSdkInit from "@/libs/wx.init.js";
import { isWeiXin, getCurrentAppkey } from "@/libs/utils";

export default {
  name: "",
  data() {
    return {
      result: 0, // 0.失败 1.成功
      resultShow: false,
      authVisible: false
    };
  },
  computed: {
    // 获取微信授权 appId，优先从 URL 参数获取
    wxAppId() {
      return this.$route.query.wx_app_id || this.$route.meta.auth;
    },
    // 根据域名判断使用哪个 appkey，悦玩域名使用 ywAppkey
    currentAppkey() {
      return getCurrentAppkey(this.$route);
    }
  },
  created() {
    const is_snapshotuser = localStorage.getItem("is_snapshotuser")
    if (is_snapshotuser == 1) this.authVisible = true;
  },
  mounted() {
    if (isWeiXin()) wxSdkInit(this.currentAppkey, this.wxAppId);
    const { order_sn } = this.$route.query;
    if (order_sn) {
      this.charge(order_sn);
    } else {
      this.getOrderSn()
    }
  },
  methods: {
    async charge(order_sn) {
      await checkOs({ order_sn });
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (!order_sn) return;
      const r = await officialAccountsPay({
        appkey: this.currentAppkey,
        order_sn,
        wx_app_id: this.wxAppId,
        open_id: userInfo.open_id,
      });
      const { nonceStr, paySign, timeStamp, signType } = r.content;
      wx.chooseWXPay({
        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr, // 支付签名随机串，不长于 32 位
        package: r.content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign, // 支付签名
        success: (res) => {
          this.checkOrder(order_sn);
        },
        fail: (err) => {
          this.checkOrder(order_sn);
        },
        cancel: () => {
          this.checkOrder(order_sn);
        },
      });
    },
    async checkOrder(order_sn) {
      const r = await checkOrderApi({ order_sn });
      const { pay_status } = r.content;
      this.resultShow = true;
      if (pay_status == 1) {
        this.result = 1;
        this.$toast("支付成功，实际支付结果请以游戏内为准");
      } else {
        this.result = 0;
        this.$toast("支付失败，实际支付结果请以游戏内为准");
      }
    },
    async getOrderSn() {
      let userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        const r = await getOrderSn({ unionid: userInfo.real_union_id });
        this.charge(r.content.order_sn)
      }
    }
  },
};
</script>

<style lang="scss" module>
.result {
  height: 100%;
  background: #000000;
  .content {
    background: #3a1205;
    border: {
      top: 1px solid rgba(118, 109, 91, 1);
      bottom: 1px solid rgba(118, 109, 91, 1);
    }
    padding: 40px 0 40px;
    img {
      display: block;
      margin: auto;
    }
    .state {
      width: 130px;
      height: 130px;
      margin-bottom: 20px;
    }
    .success {
      color: #ffda7d;
    }
    p {
      color: #d22c2c;
      font-size: 28px;
      letter-spacing: 2px;
      text-align: center;
    }
    .contact,
    .back {
      width: 180px;
    }
    .contact {
      margin-top: 36px;
      margin-bottom: 19px;
    }
    .desc {
      font-size: 15px;
      color: #ffda7d;
      margin: 18px 0 25px;
    }
  }
  .auth {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
  }
}
</style>